import * as React from 'react'
import ControlItems from './items'

export default function TabItems({ vehicleTypeId }) {
  return <ControlItems vehicleTypeId={vehicleTypeId} />
}
